export default "__VITE_ASSET__8e736b94__"